export default __webpack_public_path__ + "static/media/gastrotipps.6cfa7485.webp";